import { login,loginout, selectUserInfo,updateUserInfo } from "@/request/user";
import router from "@/router"
import { message } from 'ant-design-vue';

let userinfo = localStorage.getItem("userinfo") ? JSON.parse((localStorage as any).getItem("userinfo")):null
const token = localStorage.getItem("token")? JSON.parse((localStorage as any).getItem("token")): "";

export default {
    namespaced:true,
    state:{
        userinfo,
        showinfo:false,
        searchStr:'',
        searchBtnFlagNum:0
    },
    getters:{
       userinfo:(state:any) => state.userinfo,
       showinfo:(state:any) => state.showinfo,
       searchStr:(state:any) => state.searchStr,//查询条件
       searchBtnFlagNum:(state:any) => state.searchBtnFlagNum,//查询条件按钮点击技术
    },
    mutations:{
       SET_USERINFO(state:any, data:any){
           // 存入本地存储是为了实现持久化！
           if(data){
            localStorage.setItem("userinfo",JSON.stringify(data))
           }
           // 存入vuex是为了各组件方便直接拿取数据
           state.userinfo = data;
       },
       SET_SHOWINFO(state:any, data:any){
           state.showinfo = data
       },
       SET_SEARCHSTR(state:any, data:any){
        state.searchStr = data
        },
        SET_SEARCHBTNFLAGNUM(state:any, data:any){
            state.searchBtnFlagNum = data
        },
    },
    actions:{
        async login({commit}:any,code:any){
            const res = await login(code);
            if(res.data.code==0){
                commit('SET_USERINFO',res.data.user)
                if(res.data.token){
                    localStorage.setItem("token",JSON.stringify(res.data.token))
                }else if(res.data.code==401){
                    localStorage.removeItem("userinfo")
                    localStorage.removeItem("token")
                }
                let state = localStorage.getItem('state')?localStorage.getItem('state'):''
                let userinfo = localStorage.getItem('userinfo')?JSON.parse((localStorage as any).getItem('userinfo')):null
                if(userinfo && (!userinfo.cardNumber || !userinfo.userName)){
                    commit('SET_SHOWINFO',true)
                }
                router.push((state as any))
            }else{
            }
        },
        async selectUserInfo({commit,dispatch}:any){
            let token = localStorage.getItem("token")? JSON.parse((localStorage as any).getItem("token")): "";
            const res = await selectUserInfo(token)
            if(res.status==200){
                commit('SET_USERINFO',res.data.user)
                if(res.data.user && (res.data.user.cardNumber && res.data.user.userName)){
                    commit('SET_SHOWINFO',false)
                    // dispatch('certificate/SearchExamResult',null,{root:true})
                }
            }else if(res.data.code==401){
                localStorage.removeItem("userinfo")
                localStorage.removeItem("token")
            }
        },
        async updateUserInfo({commit,dispatch}:any,data:any){
            let token = localStorage.getItem("token")? JSON.parse((localStorage as any).getItem("token")): "";
            return await updateUserInfo(data,token)
        },
        async setSearchStr({commit,dispatch}:any,data:any){
            commit('SET_SEARCHSTR',data)
        },
        async setSearchBtnFlagNum({commit,dispatch}:any,data:any){
            commit('SET_SEARCHBTNFLAGNUM',data)
        }
    }
}